// extracted by mini-css-extract-plugin
export default {"p":"_01d9e45e04 _4f09e1a2b9 aec4c86e50","clr":"_7c5debaf4a","dls":"_4e4911d5b9"};